var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneFlagForFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 20C1.1875 28.1875 6.4375 35.125 13.6875 37.6875V2.3125C6.4375 4.875 1.1875 11.8125 1.1875 20Z",
    fill: "#002654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6875 20C38.6875 11.8125 33.5 4.875 26.1875 2.3125V37.6875C33.5 35.125 38.6875 28.1875 38.6875 20Z",
    fill: "#CE1126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6875 37.6875C15.625 38.375 17.75 38.75 19.9375 38.75C22.125 38.75 24.25 38.375 26.1875 37.6875V2.3125C24.25 1.625 22.1875 1.25 19.9375 1.25C17.6875 1.25 15.625 1.625 13.6875 2.3125V37.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneFlagForFrance);
export default __webpack_public_path__ + "static/media/emojione_flag-for-france.2338b79877fd5fdfa1c1efc9f37ad7e4.svg";
export { ForwardRef as ReactComponent };